import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/',
        component: () => import('@/widgets/main-layout').then(m => m.MainLayout),
        children: [
            {
                path: '/',
                name: 'Dashboard',
                component: () => import('@/pages/dashboard'),
            },
            {
                path: '/agreement/:id',
                name: 'Agreement',
                component: () => import('@/pages/reports/check-agreement-document'),
            },
            {
                path: '/notification/:id',
                name: 'Notification',
                component: () => import('@/pages/reports/check-notification-document'),
            },
            {
                path: '/recall_notification/:id',
                name: 'RecallNotification',
                component: () => import('@/pages/reports/check-recall-notification-document'),
            },
            {
                path: '/register/:id',
                name: 'Register',
                component: () => import('@/pages/reports/check-register-document'),
            },
            {
                path: '/organization_warranty/:id',
                name: 'OrganizationWarranty',
                component: () => import('@/pages/reports/check-organization-warranty'),
            },
            {
                path: '/organization_decision/:id',
                name: 'OrganizationDecision',
                component: () => import('@/pages/reports/check-organization-decision'),
            },
            {
                path: '/email-notification-for-debtor/:id',
                name: 'EmailNotificationForDebtor',
                component: () => import('@/pages/reports/check-email-notification-for-debtor'),
            },
            {
                path: '/email-notification-for-client/:id',
                name: 'EmailNotificationForClient',
                component: () => import('@/pages/reports/check-email-notification-for-client'),
            },
            {
                path: '/email-notification-for-guarantor/:id',
                name: 'EmailNotificationForGuarantor',
                component: () => import('@/pages/reports/check-email-notification-for-guarantor'),
            },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: () => import('@/pages/not-found')
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
